import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ScrollToPlugin } from "gsap/ScrollToPlugin";


// document.addEventListener("DOMContentLoaded", () => {
window.addEventListener("load", function(){
  gsap.registerPlugin(ScrollTrigger);

  const isSP = window.matchMedia("(max-width: 768px)").matches;

  const section = document.querySelector(".p-newgradsstory_main");
  const pinSection = document.querySelector(".j-newgradsstory_pin");
  const contWrap = document.querySelector(".j-newgradsstory_wrap");
  const contList = document.querySelector(".j-newgradsstory_cont");
  const panels = document.querySelectorAll(".p-newgradsstory_main_cmn");
  const nav = document.querySelectorAll(".p-newgradsstory_main_nav");
  const navItems = document.querySelectorAll(".p-newgradsstory_main_nav_cmn");
  const ship = document.querySelector(".p-newgradsstory_main_ship");
  const shipLine = document.querySelector(".p-newgradsstory_main_ship_line");
  const stepBtn = document.querySelectorAll(".p-newgradsstory_main_cmn_detail_next_step");

  const totalScrollWidth = contList.scrollWidth - contWrap.clientWidth;

  //-------------- PC（横スクロール）
  if (!isSP) {
    console.log('pc');

    const horizScroll = gsap.to(contList, {
      x: () => -totalScrollWidth,
      ease: "none",
      scrollTrigger: {
        // id: "horizScroll",
        trigger: ".p-newgradsstory_main",
        start: "top top",
        end: () => `+=${totalScrollWidth}`,
        scrub: true,
        pin: pinSection,
        anticipatePin: 1,
        invalidateOnRefresh: true,
      }
    });

    panels.forEach((panel, index) => {
      ScrollTrigger.create({
        trigger: panel,
        start: "left center",
        end: "right center",
        horizontal: true,
        containerAnimation: horizScroll,
        onEnter: () => {
          navItems.forEach(n => n.classList.remove("active"));
          navItems[index].classList.add("active");
        },
        onEnterBack: () => {
          navItems.forEach(n => n.classList.remove("active"));
          navItems[index].classList.add("active");
        }
      });
    });


    navItems.forEach((nav, i) => {
      // const link = nav.querySelector("a");
      nav.addEventListener("click", (e) => {
        const scrollTopToElement = section.getBoundingClientRect().top + window.scrollY;

        const panel = panels[i];
        if (!panel) return;

        // パネルの左端位置を取得
        const offset = panel.offsetLeft + scrollTopToElement;

        // Lenis でふわっと移動
        window.lenis.scrollTo(offset, {
          duration: 1.2,       // スクロール時間（好みで変更）
          easing: (x) => 1 - Math.pow(1 - x, 3), // しっとり減速カーブ
        });
      });
    });

    stepBtn.forEach((step, i) => {
      // const link = nav.querySelector("a");
      step.addEventListener("click", (e) => {
        const scrollTopToElement = section.getBoundingClientRect().top + window.scrollY;

        const panel = panels[i + 1];
        if (!panel) return;

        // パネルの左端位置を取得
        const offset = panel.offsetLeft + scrollTopToElement;

        // Lenis でふわっと移動
        window.lenis.scrollTo(offset, {
          duration: 1.2,       // スクロール時間（好みで変更）
          easing: (x) => 1 - Math.pow(1 - x, 3), // しっとり減速カーブ
        });
      });
    });

    //****************
    // 船ラインは共通
    //****************
    gsap.fromTo(
      shipLine,
      { width: "0%" },
      {
        width: "100%",
        ease: "none",
        scrollTrigger: {
          trigger: ".p-newgradsstory_main",
          start: "top top",
          end: () => `+=${totalScrollWidth}`,
          scrub: 1,
        }
      }
    );
  }

  //-------------- SP（縦スクロール）
  if (isSP) {
    console.log('sp');
    ScrollTrigger.create({
      trigger: section,
      start: "top top",
      end: "bottom bottom",
      pin: nav,
      pinSpacing: false,
      // markers: true,
    });
    ScrollTrigger.create({
      trigger: section,
      start: "top top",
      end: "bottom bottom",
      pin: ship,
      pinSpacing: false,
      // markers: true,         // デバッグ用
    });

    panels.forEach((panel, index) => {
      ScrollTrigger.create({
        trigger: panel,
        start: "top center",
        end: "bottom center",
        onEnter: () => {
          navItems.forEach(n => n.classList.remove("active"));
          navItems[index].classList.add("active");
        },
        onEnterBack: () => {
          navItems.forEach(n => n.classList.remove("active"));
          navItems[index].classList.add("active");
        }
      });
    });

    navItems.forEach((nav, i) => {
      // const link = nav.querySelector("a");
      nav.addEventListener("click", (e) => {
        const scrollTopToElement = section.getBoundingClientRect().top + window.scrollY;

        const panel = panels[i];
        if (!panel) return;

        // パネルの左端位置を取得
        const offset = panel.offsetTop + scrollTopToElement;

        // Lenis でふわっと移動
        window.lenis.scrollTo(offset, {
          duration: 1.2,       // スクロール時間（好みで変更）
          easing: (x) => 1 - Math.pow(1 - x, 3), // しっとり減速カーブ
        });
      });
    });
    stepBtn.forEach((step, i) => {
      // const link = nav.querySelector("a");
      step.addEventListener("click", (e) => {
        const scrollTopToElement = section.getBoundingClientRect().top + window.scrollY;

        const panel = panels[i + 1];
        if (!panel) return;

        // パネルの左端位置を取得
        const offset = panel.offsetTop + scrollTopToElement;

        // Lenis でふわっと移動
        window.lenis.scrollTo(offset, {
          duration: 1.2,       // スクロール時間（好みで変更）
          easing: (x) => 1 - Math.pow(1 - x, 3), // しっとり減速カーブ
        });
      });
    });

    //****************
    // 船ラインは共通
    //****************
    gsap.fromTo(
      shipLine,
      { width: "0%" },
      {
        width: "100%",
        ease: "none",
        scrollTrigger: {
          trigger: ".p-newgradsstory_main",
          start: "top top",
          end: "bottom bottom",
          scrub: 1,
        }
      }
    );
  }


  // //****************
  // // 船ラインは共通
  // //****************
  // gsap.fromTo(
  //   shipLine,
  //   { width: "0%" },
  //   {
  //     width: "100%",
  //     ease: "none",
  //     scrollTrigger: {
  //       trigger: ".p-newgradsstory_main",
  //       start: "top top",
  //       end: () => `+=${totalScrollWidth}`,
  //       scrub: 1,
  //     }
  //   }
  // );


  // すべてのモーダル、開くボタン、閉じるボタンを取得
  const modals = document.querySelectorAll('.js-modal');
const openButtons = document.querySelectorAll('.js-modal-open');
const closeButtons = document.querySelectorAll('.js-modal-close');

// 開く
openButtons.forEach((btn) => {
  btn.addEventListener('click', () => {
    const targetId = btn.dataset.target;
    const modal = document.getElementById(targetId);
    if (!modal) return;

    modal.classList.add('is-active');
    document.body.classList.add('is-fixed');

    if (window.lenis) {
      window.lenis.stop();
    }
  });
});

// 閉じる
closeButtons.forEach((btn) => {
  btn.addEventListener('click', () => {
    const modal = btn.closest('.js-modal');
    if (!modal) return;

    modal.classList.remove('is-active');
    document.body.classList.remove('is-fixed');

    if (window.lenis) {
      window.lenis.start();
    }
  });
});

// 背景クリックで閉じる
modals.forEach((modal) => {
  modal.addEventListener('click', (e) => {
    if (e.target !== modal) return;

    modal.classList.remove('is-active');
    document.body.classList.remove('is-fixed');

    if (window.lenis) {
      window.lenis.start();
    }
  });
});



});


const isMobile = window.matchMedia("(max-width: 768px)").matches;

if(!isMobile) {
  let resizeTimer;

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      location.reload();
    }, 500); // ← 0.5秒後にリロード
  });
}
